import { CSSProperties, memo, useMemo } from "react";
import { GridTotalColumnRow } from "../../../../../../../../api/generated/data-contracts";
import { useGridLayoutContext } from "../../../context/LayoutContext";
import { BORDER, ROW_HEIGHT, TOTAL_COLUMN_WIDTH } from "../../../CONSTANTS";
import { ReadOnlyCell } from "./resource/ReadOnlyCell";


export const TotalColumnContainer = memo(function TotalColumnContainer({ column }: { column: GridTotalColumnRow }) {
    const { rowHeaderSize } = useGridLayoutContext();
    
	const style = useMemo(() => {
        return {
            width: `${TOTAL_COLUMN_WIDTH}px`,
            position: 'sticky',
            top: 0,
            left: rowHeaderSize,
            height: `${ROW_HEIGHT}px`,
            boxSizing: 'border-box',
            borderBottom: BORDER,
            borderRight: BORDER,
            zIndex: 1,
            backgroundColor: 'inherit',
            display: 'grid',
            gridTemplateColumns: `1fr 1fr`,
        } as CSSProperties;
    }, [rowHeaderSize]);

    return (
        <div style={style}>
            {column.cells.map(cell => (
                <ReadOnlyCell key={cell.id} cell={cell} />
            ))}
        </div>
    );
});